module.exports = {
  'all': [
    ['EOP', 'FP'],
    ['SKE', 'KRIP', 'VL'],
  ],
  '01': [
    ['KESK', 'KD', 'KL'],
  ],
  '07': [
    ['KOK', 'RKP'],
  ],
  '08': [
    ['KOK', 'RKP'],
  ],
  '12': [
    ['KD', 'KL'],
  ],
  '13': [
    ['KOK', 'KD'],
  ],
}

// const districtsData = {}
// for (const districtId in districtPartyAlliances) {
//   const partyAlliances = districtPartyAlliances[districtId]

//   const candidates = candidateData[districtId]
//   for (const number in candidates) {
//     const matchingPartyAlliance = partyAlliances.find(alliance => alliance.includes(candidates[number].party))

//     if (matchingPartyAlliance) {
//       candidates[number].partyAlliance = matchingPartyAlliance.join('+')
//     } else {
//       candidates[number].partyAlliance = candidates[number].party
//     }
//   }

//   districtsData[districtId] = {
//     candidates,
//     partyAlliances,
//     paikat: vaalipiiriPaikat[districtId],
//     votes: [],
//   }
// }